import {NgModule} from '@angular/core';
import {CoreModule} from "../../core/core.module";
import {HA_ENTITY_PROVIDER} from "./ha.entity-provider";
import {HA_TEST_PROVIDERS} from "./test/ha-test-definition";
import {
    AlphaBatchEntityObjectBaseComponent
} from "./component/object-components/alpha-batch-entity-object-base-component/alpha-batch-entity-object-base.component";
import {
    AlphaBatchEntityFullComponent
} from "./component/object-components/alpha-batch-entity-object-base-component/view/alpha-batch-entity-full-component/alpha-batch-entity-full.component";
import {
    AlphaBatchEntitySideComponent
} from "./component/object-components/alpha-batch-entity-object-base-component/view/alpha-batch-entity-side-component/alpha-batch-entity-side.component";
import {
    AlphaBatchEntityBaseComponent
} from "./component/object-components/alpha-batch-entity-object-base-component/view/alpha-batch-entity-base.component";
import {HaConfigPage} from "./page/overview/config/ha-config.page";

@NgModule({
    declarations: [

        AlphaBatchEntityObjectBaseComponent,
        AlphaBatchEntityFullComponent,
        AlphaBatchEntitySideComponent,
        AlphaBatchEntityBaseComponent,
        HaConfigPage,
    ],
    exports: [
    ],
    imports: [
        CoreModule

    ],
    providers: [HA_ENTITY_PROVIDER, HA_TEST_PROVIDERS]
})
export class HaModule {
}
 
 
 
